import { Button, Stack, Typography } from '@mui/material';
import { DefinitionList, DialogSurface } from '../../design-system';
import type { AbsenceDateRange } from './useCalendarRangeSelection';

export function absenceDraftPeriod(startDate: string, endDate: string) {
  if (!startDate && !endDate) return '날짜 미선택';
  if (startDate === endDate) return startDate;
  return `${startDate || '시작일 미선택'} ~ ${endDate || '종료일 미선택'}`;
}

export function AbsenceRequestDraftChoice({ open, currentType, currentStatus, currentRange, nextType, nextRange, canReplace, onClose, onResume, onReplace }: {
  open: boolean;
  currentType: string;
  currentStatus: string;
  currentRange: AbsenceDateRange;
  nextType: string;
  nextRange?: AbsenceDateRange;
  canReplace: boolean;
  onClose: () => void;
  onResume: () => void;
  onReplace: () => void;
}) {
  return <DialogSurface open={open} onClose={onClose} title="작성 중인 휴가 신청이 있습니다" size="compact" mobilePresentation="dialog" actions={<>
    <Button variant="outlined" onClick={onResume}>이어서 작성</Button>
    {canReplace && <Button variant="contained" onClick={onReplace}>{nextRange ? '새 일정으로 작성' : '새 유형으로 작성'}</Button>}
  </>}>
    <Stack spacing={2}>
      <DefinitionList items={[
        [currentStatus, `${currentType} · ${absenceDraftPeriod(currentRange.startDate, currentRange.endDate)}`],
        ['새로 선택', `${nextType}${nextRange ? ` · ${absenceDraftPeriod(nextRange.startDate, nextRange.endDate)}` : ''}`],
      ]} />
      <Typography variant="body2" color="text.secondary">{canReplace
        ? '새로 작성하면 기존 입력과 첨부 선택이 지워집니다.'
        : '저장된 신청의 제출 결과를 먼저 확인해 주세요. 해당 신청을 마치거나 신청 이력에서 취소한 뒤 새로 작성할 수 있습니다.'}</Typography>
    </Stack>
  </DialogSurface>;
}
